import { GoalDTO, GoalExplanationListDTO, GoalTypeDTO } from '../../types/goalsDTO';

const ASSUMPTIONS_EXPLANATIONS = {
  Section: 'Assumptions',
};

interface GoalExplanations extends Omit<GoalExplanationListDTO, 'Section' | 'Message' | 'Title'> {
  Section?: string;
  Message?: string;
  Title?: string;
}

export const getGoalExplanations = (goal: GoalDTO): GoalExplanations[] | null => {
  if (!goal || !goal.GoalExplanations) {
    return null;
  }

  const { GoalExplanations } = goal;

  if (goal.GoalType === GoalTypeDTO.EstatePlanning) {
    return GoalExplanations as GoalExplanations[];
  }

  if (Array.isArray(GoalExplanations)) {
    return [...GoalExplanations, ASSUMPTIONS_EXPLANATIONS];
  }

  return [GoalExplanations, ASSUMPTIONS_EXPLANATIONS];
};
